jQuery(document).ready(function ($) {
  $('.phone-desktop .phone-element__link').click(function(e){
    e.preventDefault();
    toggleWindowVisibility();
  });

  var toggleWindowVisibility = function(){
    $('.phone-element__window').toggleClass('is-visible');
  };

  $( window ).resize(function() {
    if($('.phone-element__window').hasClass('is-visible')){
      $('.phone-element__window').removeClass('is-visible');
    }
  });
});